<template>
  <div class="grid" id="datosClienteAcreedorDeudor">
    <div class="col-12">
      <Panel :header="$t('operacion.detalleOperacion.usuarios')">
        <div class="grid">
          <div class="col-12">
            <Accordion v-if="cliente">
              <AccordionTab :active="activeUsuarios">
                <template slot="header">
                  <span
                    >{{ $t("operacion.detalleOperacion.cliente") }} :
                    {{ cliente.nombre }} {{ cliente.apellidos }}</span
                  >
                </template>
                <DataTable
                  :value="[cliente]"
                  class="p-datatable-responsive-demo"
                >
                  <Column
                    field="fechaAlta"
                    :header="$t('operacion.detalleOperacion.fechaAlta')"
                  >
                    <template #body="slotProps">
                      {{ getFormattedDateLong(slotProps.data.fechaAlta) }}
                    </template>
                  </Column>
                  <Column
                    field="nombre"
                    :header="$t('operacion.detalleOperacion.nombreUsuario')"
                  ></Column>
                  <Column
                    field="apellidos"
                    :header="$t('operacion.detalleOperacion.apellidosUsuario')"
                  ></Column>
                  <Column
                    field="idLegal"
                    :header="$t('operacion.detalleOperacion.nifDniNie')"
                  ></Column>
                  <Column
                    field="iban"
                    headerStyle="width: 17em"
                    :header="$t('operacion.detalleOperacion.iban')"
                  ></Column>
                  <Column
                    headerStyle="width: 5em"
                    bodyStyle="text-align: center"
                  >
                    <template #body="slotProps">
                      <Button
                        v-if="permitirDetalleCliente"
                        icon="pi pi-search"
                        @click="gotoDetalle(slotProps.data.idLegal)"
                        class="p-button-success"
                        style="margin-right: 0.5em"
                      ></Button>
                    </template>
                  </Column>
                </DataTable>
              </AccordionTab>
            </Accordion>
          </div>
        </div>
        <div class="grid">
          <div class="col-6">
            <Accordion v-if="detalleOperacion.acreedor">
              <AccordionTab :active="activeUsuarios">
                <template slot="header">
                  <Button
                    v-if="permitirEditarUsuario"
                    @click.stop="modalModificarAcreedor()"
                    :label="$t('common.buttons.edit')"
                    class="
                      p-button p-button-icon-only p-button-text
                      transparent
                    "
                    icon="pi pi-pencil"
                    iconPos="left"
                  />
                  <NombreRazonSocialAcreedorDeudor
                    :tipoUsuario="detalleOperacion.acreedor.tipo"
                    :esHeader="true"
                    :idLegal="detalleOperacion.acreedor.idLegal"
                    :tituloHeader="$t('operacion.detalleOperacion.acreedor')"
                    :nombre="detalleOperacion.acreedor.nombre"
                    :apellidos="detalleOperacion.acreedor.apellidos"
                    :razonSocial="detalleOperacion.acreedor.razonSocial"
                  />
                </template>
                <div class="grid">
                  <div class="col-6">
                    <NombreRazonSocialAcreedorDeudor
                      :tipoUsuario="detalleOperacion.acreedor.tipo"
                      :esHeader="false"
                      :idLegal="detalleOperacion.acreedor.idLegal"
                      :nombre="detalleOperacion.acreedor.nombre"
                      :apellidos="detalleOperacion.acreedor.apellidos"
                      :razonSocial="detalleOperacion.acreedor.razonSocial"
                    />
                    <p>
                      <b>{{ $t("operacion.detalleOperacion.nifDniNie") }}:</b>
                      {{ detalleOperacion.acreedor.idLegal }}
                    </p>
                  </div>
                  <div class="col-6">
                    <p
                      v-if="
                        detalleOperacion.acreedor.literalTipoUsuarioDetalle &&
                        detalleOperacion.acreedor.literalTipoUsuarioDetalle
                          .valor
                      "
                    >
                      <b>{{ $t("operacion.detalleOperacion.tipoEntidad") }}:</b>
                      {{
                        detalleOperacion.acreedor.literalTipoUsuarioDetalle
                          .valor
                      }}
                    </p>
                    <p
                      v-if="
                        detalleOperacion.acreedor.literalTipoSociedadDetalle &&
                        detalleOperacion.acreedor.literalTipoSociedadDetalle
                          .valor
                      "
                    >
                      <b
                        >{{ $t("operacion.detalleOperacion.tipoSociedad") }}:</b
                      >
                      {{
                        detalleOperacion.acreedor.literalTipoSociedadDetalle
                          .valor
                      }}
                    </p>
                    <p v-if="detalleOperacion.acreedor.cnae">
                      <b>{{ $t("operacion.detalleOperacion.cnae") }}:</b>
                      {{
                        detalleOperacion.acreedor.literalTipoCnae &&
                        detalleOperacion.acreedor.literalTipoCnae.valor
                          ? detalleOperacion.acreedor.cnae +
                            " - " +
                            detalleOperacion.acreedor.literalTipoCnae.valor
                          : detalleOperacion.acreedor.cnae
                      }}
                    </p>
                  </div>
                </div>
                <ListaContactos
                  :id="detalleOperacion.acreedor.id"
                  propietario="usuario"
                  v-bind:permitirEditar="true"
                />
              </AccordionTab>
            </Accordion>
          </div>
          <div class="col-6">
            <Accordion v-if="detalleOperacion.deudor">
              <AccordionTab
                :key="detalleOperacion.deudor.id"
                :active="activeUsuarios"
              >
                <template slot="header">
                  <Button
                    v-if="permitirEditarUsuario"
                    @click.stop="modalModificarDeudor()"
                    :label="$t('common.buttons.edit')"
                    class="
                      p-button p-button-icon-only p-button-text
                      transparent
                    "
                    icon="pi pi-pencil"
                    iconPos="left"
                  />
                  <NombreRazonSocialAcreedorDeudor
                    :tipoUsuario="detalleOperacion.deudor.tipo"
                    :esHeader="true"
                    :idLegal="detalleOperacion.deudor.idLegal"
                    :tituloHeader="$t('operacion.detalleOperacion.deudor')"
                    :nombre="detalleOperacion.deudor.nombre"
                    :apellidos="detalleOperacion.deudor.apellidos"
                    :razonSocial="detalleOperacion.deudor.razonSocial"
                  />
                </template>
                <div class="grid">
                  <div class="col-6">
                    <NombreRazonSocialAcreedorDeudor
                      :tipoUsuario="detalleOperacion.deudor.tipo"
                      :esHeader="false"
                      :idLegal="detalleOperacion.deudor.idLegal"
                      :nombre="detalleOperacion.deudor.nombre"
                      :apellidos="detalleOperacion.deudor.apellidos"
                      :razonSocial="detalleOperacion.deudor.razonSocial"
                    />
                    <p>
                      <b>{{ $t("operacion.detalleOperacion.nifDniNie") }}:</b>
                      {{ detalleOperacion.deudor.idLegal }}
                    </p>
                  </div>
                  <div class="col-6">
                    <p
                      v-if="
                        detalleOperacion.deudor.literalTipoUsuarioDetalle &&
                        detalleOperacion.deudor.literalTipoUsuarioDetalle.valor
                      "
                    >
                      <b>{{ $t("operacion.detalleOperacion.tipoEntidad") }}:</b>
                      {{
                        detalleOperacion.deudor.literalTipoUsuarioDetalle.valor
                      }}
                    </p>
                    <p
                      v-if="
                        detalleOperacion.deudor.literalTipoSociedadDetalle &&
                        detalleOperacion.deudor.literalTipoSociedadDetalle.valor
                      "
                    >
                      <b
                        >{{ $t("operacion.detalleOperacion.tipoSociedad") }}:</b
                      >
                      {{
                        detalleOperacion.deudor.literalTipoSociedadDetalle.valor
                      }}
                    </p>
                    <p v-if="detalleOperacion.deudor.cnae">
                      <b>{{ $t("operacion.detalleOperacion.cnae") }}:</b>
                      {{
                        detalleOperacion.deudor.literalTipoCnae &&
                        detalleOperacion.deudor.literalTipoCnae.valor
                          ? detalleOperacion.deudor.cnae +
                            " - " +
                            detalleOperacion.deudor.literalTipoCnae.valor
                          : detalleOperacion.deudor.cnae
                      }}
                    </p>
                  </div>
                </div>
                <ListaContactos
                  :id="detalleOperacion.deudor.id"
                  propietario="usuario"
                  v-bind:permitirEditar="true"
                />
              </AccordionTab>
            </Accordion>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>
<script>
import AbilitiesMixin from "@/utils/ability";

import ListaContactos from "@/components/portal-gran-cliente/util/ListaContactos.vue";
import NombreRazonSocialAcreedorDeudor from "@/components/utilidades/NombreRazonSocialAcreedorDeudor.vue";
export default {
  name: "DatosClienteAcreedorDeudor",
  mixins: [AbilitiesMixin],
  components: {
    NombreRazonSocialAcreedorDeudor: NombreRazonSocialAcreedorDeudor,
    ListaContactos: ListaContactos,
  },
  props: ["detalleOperacion"],
  data() {
    return {
      permitirEditarUsuario: false,
      permitirDetalleCliente: false,
      permitirEditarOrigenDeuda: false,
    };
  },
  created() {
    this.permitirEditarUsuario = this.checkAbility("editarUsuario");
    this.permitirDetalleCliente = this.checkAbility("editarCliente");
    this.permitirEditarOrigenDeuda = this.checkAbility("editarOperacion");
  },
};
</script>